import {LinkButton} from '@components/common/button/button'
import {Loading} from '@components/common/loading/loading'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {useStatsTimelineStore} from '../stats-timeline-store'
import ShowMoreSVG from './show-more.svg'

export const ShowMore = observer(() => {
  const [state, store] = useStatsTimelineStore()
  return (
    state.isEventsLeft &&
    Object.keys(store.events).length > 0 && (
      <div
        className={`mt-12 mb-12 ${state.view === 'card' ? 'ml-88' : 'ml-0'}`}
      >
        {state.isFetching ? (
          <div className={`${state.view === 'card' ? 'ml-34' : 'ml-24'}`}>
            <Loading />
          </div>
        ) : (
          <>
            <LinkButton
              onClick={() => {
                const isLocationFilter = state.filter?.located?.length > 0
                isLocationFilter ? store.loadMoreLocation() : store.loadMore()
              }}
            >
              <ShowMoreContent />
            </LinkButton>
          </>
        )}
      </div>
    )
  )
})

export const ShowMoreContent = () => {
  return (
    <>
      <div className="flex mr-4">
        <ShowMoreSVG />
      </div>
      {Lang.msg.statsTimeline.showMore}
    </>
  )
}
